<!--<link href="/css/layout.css" rel="stylesheet" type="text/css" media="all" />
<link href="/css/style.css" rel="stylesheet" type="text/css" media="all" />-->

<link href="/css/mat-theme.css" rel="stylesheet" type="text/css" media="all" />

<div class="bg-wrap">
  <div id="loadingOverlay" class="mb-loading-hide">
    <div class="md-loadingRect">
      <div class="md-loadingRectChild md-loadingRect1"></div>
      <div class="md-loadingRectChild md-loadingRect2"></div>
      <div class="md-loadingRectChild md-loadingRect3"></div>
      <div class="md-loadingRectChild md-loadingRect4"></div>
      <div class="md-loadingRectChild md-loadingRect5"></div>
      <div class="md-loading-text">Loading...</div>
    </div>
    <div class="md-loading-mask"></div>
  </div>

  <modal-layout></modal-layout>

  <div class="container nopadding">
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#menu-top" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <div class="navbar-brand"><a href=""><img src="/images/logo-main.png" /></a></div>
        </div>

        <div class="collapse navbar-collapse" id="menu-top">
          <ul class="nav navbar-nav navbar-right">
            <li><a href="https://mind-berry.com/">Home</a></li>
            <li><a href="https://mind-berry.com/companies">Companies</a></li>
            <li><a href="https://mind-berry.com/professionals">Professionals</a></li>
            <li><a href="https://mind-berry.com/contact">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="body-outer">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <footer-layout></footer-layout>
</div>


